import OpportunitiesListTable from "./components/OpportunitiesListTable";

export default OpportunitiesListTable